/* Herb Garden × F&M look: menu drawer, product gallery, option picker, sticky add to cart. No dependencies. */
(function () {
  'use strict';
  var money = function (cents) { return 'Rs.' + Math.round(cents / 100).toLocaleString('en-PK'); };

  /* ---------- menu drawer ---------- */
  var lastFocus = null;
  function drawer() { return document.querySelector('[data-thg-drawer]'); }
  function openDrawer(btn) {
    var d = drawer(); if (!d) return;
    lastFocus = btn; d.hidden = false; d.classList.add('is-open');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    var c = d.querySelector('.thg-drawer__top [data-thg-close-drawer]'); if (c) c.focus();
  }
  function closeDrawer() {
    var d = drawer(); if (!d || d.hidden) return;
    d.classList.remove('is-open'); d.hidden = true; document.documentElement.style.overflow = '';
    var b = document.querySelector('[data-thg-open-drawer]'); if (b) b.setAttribute('aria-expanded', 'false');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-thg-open-drawer]'); if (o) { openDrawer(o); return; }
    if (e.target.closest('[data-thg-close-drawer]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeCart(); } });

  /* ---------- cart drawer: Add to Bag opens it, like Fable & Mane ---------- */
  var cartFocus = null;
  function cartEl() { return document.querySelector('[data-thg-cart]'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sized(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function renderCart(cart) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-thg-cart-count]'), function (c) { c.textContent = cart.item_count; c.hidden = !cart.item_count; });
    var el = cartEl(); if (!el) return;
    var list = el.querySelector('[data-thg-cart-items]');
    var empty = el.querySelector('[data-thg-cart-empty]');
    var foot = el.querySelector('[data-thg-cart-foot]');
    if (!cart.items.length) { list.innerHTML = ''; empty.hidden = false; foot.hidden = true; return; }
    empty.hidden = true; foot.hidden = false;
    list.innerHTML = cart.items.map(function (it, i) {
      var line = i + 1;
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
      return '<div class="thg-cart__item">' +
        '<a class="thg-cart__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(sized(it.image, 220)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="thg-cart__info"><a class="thg-cart__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        '<div class="thg-cart__qty"><button type="button" data-thg-line="' + line + '" data-q="' + (it.quantity - 1) + '" aria-label="One less ' + esc(it.product_title) + '">&minus;</button>' +
        '<span aria-live="polite">' + it.quantity + '</span>' +
        '<button type="button" data-thg-line="' + line + '" data-q="' + (it.quantity + 1) + '" aria-label="One more ' + esc(it.product_title) + '">+</button></div></div>' +
        '<div class="thg-cart__price">' + money(it.final_line_price) + '</div></div>';
    }).join('');
    /* discounts on the whole bag (like the quiz ritual code): one line each, above the subtotal */
    var sub = el.querySelector('[data-thg-cart-subtotal]');
    var discs = el.querySelector('[data-thg-cart-discounts]');
    if (!discs && sub && sub.parentNode && sub.parentNode.parentNode) {
      discs = document.createElement('div');
      discs.setAttribute('data-thg-cart-discounts', '');
      sub.parentNode.parentNode.insertBefore(discs, sub.parentNode);
    }
    if (discs) {
      var apps = cart.cart_level_discount_applications || [];
      discs.innerHTML = apps.map(function (a) {
        return '<div style="display:flex;justify-content:space-between;gap:12px;margin:0 0 8px;font-weight:600"><span>Discount (' + esc(a.title) + ')</span><span>&minus;' + money(a.total_allocated_amount) + '</span></div>';
      }).join('');
      discs.hidden = !apps.length;
    }
    sub.textContent = money(cart.total_price);
  }
  function openCart(trigger) {
    var el = cartEl(); if (!el) return;
    cartFocus = trigger || document.activeElement;
    getCart().then(renderCart);
    el.hidden = false; requestAnimationFrame(function () { el.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    var c = el.querySelector('.thg-cart__top [data-thg-close-cart]'); if (c) c.focus();
  }
  function closeCart() {
    var el = cartEl(); if (!el || el.hidden) return;
    el.classList.remove('is-open'); el.hidden = true; document.documentElement.style.overflow = '';
    if (cartFocus && cartFocus.focus) cartFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-thg-open-cart]');
    if (o && cartEl() && window.fetch) { e.preventDefault(); openCart(o); return; }
    if (e.target.closest('[data-thg-close-cart]')) { closeCart(); return; }
    var q = e.target.closest('[data-thg-line]');
    if (q) {
      q.disabled = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(q.getAttribute('data-thg-line'), 10), quantity: parseInt(q.getAttribute('data-q'), 10) }) })
        .then(function (r) { return r.json(); }).then(renderCart).catch(function () { q.disabled = false; });
    }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-thg-add], [data-thg-form]');
    if (!f || !cartEl() || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btns = Array.prototype.slice.call(document.querySelectorAll('[form="' + f.id + '"][type="submit"]')).concat(Array.prototype.slice.call(f.querySelectorAll('[type="submit"]')));
    btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { openCart(btns[0]); })
      .catch(function () { f.submit(); })
      .then(function () { btns.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); }); });
  });

  /* ---------- product page ---------- */
  function initGallery(root) {
    var g = root.querySelector('[data-thg-gallery]'); if (!g) return null;
    var track = g.querySelector('[data-thg-track]');
    var items = Array.prototype.slice.call(track.children);
    var dotsEl = g.querySelector('[data-thg-dots]');
    var countEl = g.querySelector('[data-thg-count]');
    var totalEl = g.querySelector('[data-thg-total]');
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-thg-thumb]'));
    var active = 0;
    if (totalEl) totalEl.textContent = items.length;
    var dots = items.map(function () { var s = document.createElement('span'); s.className = 'thg-gallery__dot'; if (dotsEl) dotsEl.appendChild(s); return s; });
    function setActive(i) {
      active = i;
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (countEl) countEl.textContent = i + 1;
    }
    function go(i) {
      if (i < 0) i = 0; if (i > items.length - 1) i = items.length - 1;
      var it = items[i]; if (!it) return;
      track.scrollTo({ left: it.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: 'smooth' });
      setActive(i);
    }
    setActive(0);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting && en.intersectionRatio > 0.6) setActive(items.indexOf(en.target)); });
      }, { root: track, threshold: [0.6] });
      items.forEach(function (it) { io.observe(it); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-thg-thumb'), 10)); }); });
    var prev = g.querySelector('[data-thg-prev]'), next = g.querySelector('[data-thg-next]');
    if (prev) prev.addEventListener('click', function () { go(active - 1); });
    if (next) next.addEventListener('click', function () { go(active + 1); });
    return {
      showMedia: function (mediaId) {
        var hit = track.querySelector('[data-media-id="' + mediaId + '"]');
        if (hit) go(items.indexOf(hit));
      }
    };
  }

  function initPdp(root) {
    var jsonEl = root.querySelector('[data-thg-product]'); if (!jsonEl) return;
    var product; try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var variants = product.variants || [];
    var gallery = initGallery(root);
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-thg-option]'));
    var input = root.querySelector('[data-thg-variant-input]');
    var atc = root.querySelector('[data-thg-atc]');
    var atcLabel = root.querySelector('[data-thg-atc-label]');
    var atcPrice = root.querySelector('[data-thg-atc-price]');
    var now = root.querySelector('[data-thg-price-now]');
    var was = root.querySelector('[data-thg-price-was]');
    var save = root.querySelector('[data-thg-save]');
    var stick = root.querySelector('[data-thg-stick]');
    var stickPrice = root.querySelector('[data-thg-stick-price]');
    var stickBtn = root.querySelector('[data-thg-stick-btn]');

    var current = variants.filter(function (v) { return String(v.id) === String(input && input.value); })[0] || variants[0];
    var selected = current ? current.options.slice() : [];

    function matches(v, sel) { return v.options.every(function (val, i) { return sel[i] === undefined || sel[i] === val; }); }
    function find() { return variants.filter(function (v) { return matches(v, selected); })[0]; }

    function paint() {
      groups.forEach(function (g) {
        var i = parseInt(g.getAttribute('data-thg-option'), 10);
        Array.prototype.forEach.call(g.querySelectorAll('.thg-choice'), function (b) {
          var val = b.getAttribute('data-value');
          b.setAttribute('aria-pressed', String(val === selected[i]));
          var test = selected.slice(); test[i] = val;
          var ok = variants.some(function (v) { return v.available && matches(v, test); });
          b.classList.toggle('is-unavailable', !ok);
        });
        var lab = g.querySelector('[data-thg-option-label]');
        if (lab) {
          var on = Array.prototype.filter.call(g.querySelectorAll('.thg-choice'), function (b) { return b.getAttribute('data-value') === selected[i]; })[0];
          lab.textContent = (on && on.getAttribute('data-label')) || selected[i] || '';
        }
      });
      var v = find();
      if (!v) {
        if (atc) atc.disabled = true; if (stickBtn) stickBtn.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        return;
      }
      current = v;
      if (input) input.value = v.id;
      if (now) now.textContent = money(v.price);
      if (atcPrice) atcPrice.textContent = money(v.price);
      if (stickPrice) stickPrice.textContent = money(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (was) { was.hidden = !onSale; if (onSale) was.textContent = money(v.compare_at_price); }
      if (save) { save.hidden = !onSale; if (onSale) save.textContent = 'Save ' + money(v.compare_at_price - v.price); }
      if (atc) atc.disabled = !v.available;
      if (stickBtn) stickBtn.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? 'Add to Bag' : 'Sold out';
      if (v.featured_media && gallery) {
        gallery.showMedia(v.featured_media.id);
      }
      try {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (err) { /* ignore */ }
    }

    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.thg-choice'); if (!b) return;
        selected[parseInt(g.getAttribute('data-thg-option'), 10)] = b.getAttribute('data-value');
        paint();
      });
    });
    if (groups.length) paint();

    /* sticky add-to-cart once the main button has scrolled away */
    if (stick && atc && 'IntersectionObserver' in window) {
      var footer = document.querySelector('.thg-footer');
      var atcGone = false, footerIn = false;
      var update = function () {
        var on = atcGone && !footerIn;
        stick.classList.toggle('is-on', on);
        stick.setAttribute('aria-hidden', String(!on));
        if (stickBtn) stickBtn.tabIndex = on ? 0 : -1;
      };
      new IntersectionObserver(function (en) {
        atcGone = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; update();
      }).observe(atc);
      if (footer) new IntersectionObserver(function (en) { footerIn = en[0].isIntersecting; update(); }).observe(footer);
    }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-thg-pdp]'), initPdp); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
